export type FootprintListener = (rect: DOMRectReadOnly | null) => void;

function sameRect(a: DOMRectReadOnly | null, b: DOMRectReadOnly | null): boolean {
  if (a === null || b === null) return a === b;
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}

export interface FootprintEmitter {
  subscribe(listener: FootprintListener): () => void;
  /** Notifies listeners only when the rect actually changed since the last report. */
  report(rect: DOMRectReadOnly | null): void;
  clear(): void;
}

/**
 * Change-only broadcaster for the compact pill's box, so a game that yields
 * canvas space to the pill (mahjong's wall count) re-lays out only when the
 * pill appears, disappears, or resizes — not on every invite refresh.
 */
export function createFootprintEmitter(): FootprintEmitter {
  const listeners = new Set<FootprintListener>();
  let last: DOMRectReadOnly | null = null;

  return {
    subscribe(listener): () => void {
      listeners.add(listener);
      listener(last);
      return () => {
        listeners.delete(listener);
      };
    },
    report(rect): void {
      if (sameRect(rect, last)) return;
      last = rect;
      for (const listener of listeners) listener(rect);
    },
    clear(): void {
      listeners.clear();
    },
  };
}
